/**
 * Enum for Feature Flag Ids
 * @readonly
 * @enum {name: {value: string}}
 */
export const LaunchDarklyFlagsEnum = Object.freeze({
  LDReadyWageHome: 'release_ReadyWageHome',
  LDReadyWageComputeLateandUT: 'release_ReadyWageComputeLateandUT',
  LDReadyCashViewStatements: 'release_RC_ViewStatements',
  LDReadyCashHome: 'release_RC_ReadyCashHome',
});
